class ContactSidebar extends HTMLElement {
  constructor() {
    super();
    
    this.overlay = this.querySelector('.contact-sidebar-overlay');
    this.panel = this.querySelector('.contact-sidebar-panel');
    this.form = this.querySelector('#contactSidebarForm');
    this.openBtn = this.querySelector('#contactOpenBtn');
    this.closeBtn = this.querySelector('#contactCloseBtn');
    this.headerCloseBtn = this.querySelector('#contactSidebarHeaderClose');
    this.nameInput = this.querySelector('#contactSidebarName');
    this.infoInput = this.querySelector('#contactSidebarInfo');
    this.commentInput = this.querySelector('#contactSidebarComment');
    this.charCount = this.querySelector('#contactSidebarCharCount');
    this.scrollTopBtn = this.querySelector('#scrollToTopBtn');
    this.errorMessage = this.querySelector('#sidebarErrorMessage');
    this.successMessage = this.querySelector('#sidebarSuccessMessage');
    
    this.bindEvents();
  }

  bindEvents() {
    // 打开/关闭按钮
    this.openBtn?.addEventListener('click', this.open.bind(this));
    this.closeBtn?.addEventListener('click', this.close.bind(this));
    this.headerCloseBtn?.addEventListener('click', this.close.bind(this));
    
    // 点击遮罩关闭
    this.overlay?.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });
    
    // ESC 键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay?.classList.contains('active')) {
        this.close();
      }
    });
    
    // 字数统计
    this.commentInput?.addEventListener('input', this.updateCharCount.bind(this));
    
    // 表单提交
    this.form?.addEventListener('submit', this.handleSubmit.bind(this));
    
    // 回到顶部按钮
    if (this.scrollTopBtn) {
      this.scrollTopBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      window.addEventListener('scroll', this.updateScrollVisibility.bind(this), { passive: true });
      window.addEventListener('resize', this.updateScrollVisibility.bind(this));
      this.updateScrollVisibility();
    }
  }

  open() {
    this.overlay?.classList.add('active');
    this.overlay?.setAttribute('aria-hidden', 'false');
    this.openBtn?.classList.add('hidden');
    this.closeBtn?.classList.remove('hidden');
    // document.body.classList.add('overflow-hidden-sidebar');
    
    // 焦点捕获（使用 global.js 的 trapFocus）
    setTimeout(() => {
      if (typeof trapFocus === 'function') {
        trapFocus(this.panel, this.nameInput);
      } else {
        this.nameInput?.focus();
      }
    }, 150);
  }

  close() {
    this.overlay?.classList.remove('active');
    this.overlay?.setAttribute('aria-hidden', 'true');
    this.openBtn?.classList.remove('hidden');
    this.closeBtn?.classList.add('hidden');
    // document.body.classList.remove('overflow-hidden-sidebar');
    
    // 释放焦点捕获
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.openBtn);
    }
  }

  updateCharCount() {
    if (!this.commentInput || !this.charCount) return;
    const count = this.commentInput.value.length;
    const max = this.commentInput.maxLength;
    this.charCount.textContent = `${count}/${max}`;
    this.charCount.style.color = count > max * 0.9 ? '#ff6b6b' : '#8b90a0';
  }

  updateScrollVisibility() {
    if (!this.scrollTopBtn) return;
    const isMobile = window.innerWidth <= 768;
    this.scrollTopBtn.style.display = isMobile || window.scrollY > 300 ? 'inline-flex' : 'none';

    const floatingAction = this.querySelector('.floating-action');
    if (floatingAction) {
                const footer = document.getElementById('footer') || document.querySelector('.footer-area');
                const copyright = document.querySelector('.footer-copyright');
                if (footer) {
                        floatingAction.style.position = 'fixed';
                        floatingAction.style.top = 'auto';
                        const stickyBar = document.querySelector('sticky-product-bar');
                        if (stickyBar.offsetHeight > 0) {
                          floatingAction.style.bottom = isMobile ? `calc(1vw + ${stickyBar.offsetHeight}px)` : `calc(20px + ${stickyBar.offsetHeight}px)`;
                          copyright.style.marginBottom = `${stickyBar.offsetHeight}px`;
                          return;
                        }
                        floatingAction.style.bottom = isMobile ? '1vw' : '20px';
                }
            }
  }

  showError(msg) {
    if (this.successMessage) {
      this.successMessage.textContent = '';
      this.successMessage.style.display = 'none';
    }
    if (this.errorMessage) {
      this.errorMessage.textContent = ' ' + msg;
      this.errorMessage.style.display = 'block';
      this.errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  showSuccess(msg) {
    if (this.errorMessage) {
      this.errorMessage.textContent = '';
      this.errorMessage.style.display = 'none';
    }
    if (this.successMessage) {
      this.successMessage.textContent = ' ' + msg;
      this.successMessage.style.display = 'block';
      this.successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  async generateSignature(data, timestamp) {
    const secretKey = 'f4e2c437cea40580808460e75c45536863750f34edc730530a1c6d6b575056b3';
    const jsonStr = JSON.stringify(data);
    
    if (window.crypto && window.crypto.subtle) {
      const encoder = new TextEncoder();
      const keyBytes = encoder.encode(secretKey);
      const jsonBytes = encoder.encode(jsonStr);
      const timestampBuffer = new ArrayBuffer(8);
      const view = new DataView(timestampBuffer);
      const ts = BigInt(timestamp);
      view.setUint32(0, Number(ts & 0xFFFFFFFFn), true);
      view.setUint32(4, Number((ts >> 32n) & 0xFFFFFFFFn), true);
      
      const combined = new Uint8Array(timestampBuffer.byteLength + jsonBytes.length);
      combined.set(new Uint8Array(timestampBuffer), 0);
      combined.set(jsonBytes, timestampBuffer.byteLength);
      
      const key = await window.crypto.subtle.importKey('raw', keyBytes, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
      const signature = await window.crypto.subtle.sign('HMAC', key, combined);
      return Array.from(new Uint8Array(signature)).map(b => b.toString(16).padStart(2, '0')).join('');
    }
    
    throw new Error('Crypto not available');
  }

  getMd5() {
    return '7b5c50e3088a711cd08d91265d5bc4e6';
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    const name = this.nameInput?.value.trim() || '';
    const contact = this.infoInput?.value.trim() || '';
    const comment = this.commentInput?.value.trim() || '';
    
    if (!name || !contact || !comment) {
      this.showError('Please complete required fields.');
      return;
    }

    const payload = {
      type: 'OTHER',
      contact,
      description: comment,
      appVersion: '1.0.0',
      sn: '',
      firmwareVersion: '',
      bmp: '',
      osVersion: '',
      name
    };

    const timestamp = Math.floor(Date.now() / 1000);
    const submitBtn = this.form.querySelector('.message-form-submit');
    
    try {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      
      const signature = await this.generateSignature(payload, timestamp);
      const res = await fetch('https://services.plugos.net/api/operation/api/feedback/upload', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Signature': this.getMd5() + signature,
          'RequestTime': timestamp.toString()
        },
        body: JSON.stringify(payload)
      });
      
      if (!res.ok) throw new Error('Network error: ' + res.status);
      
      const data = await res.json();
      if (data && data.code === 0) {
        this.showSuccess('Message submitted successfully!');
        this.form.reset();
        this.charCount && (this.charCount.textContent = '0/200');
      } else {
        throw new Error((data && data.message) || 'Submission failed');
      }
    } catch (err) {
      console.error(err);
      this.showError('Submission failed: ' + err.message);
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Submit';
    }
  }
}

customElements.define('contact-sidebar', ContactSidebar);
